// src/app/core/mainPage/mainPagecomp/VideoSection/VideoSectionSkeleton.tsx
export function VideoSectionSkeleton() {
  return (
    <div className="px-4 py-6 mx-auto max-w-7xl animate-pulse">
      <div className="h-6 w-48 rounded bg-muted mb-4" />
      <div className="h-24 rounded-2xl bg-muted mb-4" />
      <div className="flex gap-3">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="w-64 h-48 rounded-2xl bg-muted shrink-0" />
        ))}
      </div>
    </div>
  );
}